import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Theme policy:
//  - Website + admin (all non-embed routes): ONE theme — always dark. Ignore
//    any value the embed may have written to redux/localStorage.
//  - Embed routes (/embed/...): the embed owns its theme (per-business
//    light/dark/auto + accent) via applyEmbedTheme. Don't touch it here.
const ThemeHandler = () => {
  const theme = useSelector((state) => state.theme.theme);
  const location = useLocation();

  useEffect(() => {
    const root = window.document.documentElement;
    if (location.pathname.startsWith("/embed")) return; // embed controls itself
    root.classList.remove("embed-app"); // shed any embed-only theme marker
    root.classList.add("dark"); // website/admin is dark-only
  }, [location.pathname, theme]);

  return null;
};

export default ThemeHandler;
